/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_zip.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Combines the values from two multivalued fields with a delimiter that joins them together.',
  examples: [
    'ROW a = ["x", "y", "z"], b = ["1", "2"]\n| EVAL c = mv_zip(a, b, "-")\n| KEEP a, b, c',
  ],
  params: {
    string1: 'Expression that can be null, a single value, or multiple values.',
    string2: 'Expression that can be null, a single value, or multiple values.',
    delim: 'Delimiter. Optional; if omitted, `,` is used as a default delimiter.',
  },
};

export default docs;
